/*
 * @Description: axios 封装网络请求
 */

import { useStore } from '@/store'
import HttpClient, { HttpClientConfig } from 'axios-mapper'
import networkConfig from '@/config/default/net.config'
import axios from 'axios'
import { Method, RequestParams } from 'axios-mapper/src/type'

const https = (hasToken: Boolean = true) => {
  const config: HttpClientConfig = {
    baseURL: networkConfig.host,
    headers: {
      Authorization: hasToken ? useStore().state.user.token : ''
    }
  }
  return new HttpClient(config)
}

export default https

export const downloadExcel = (
  url: string,
  method: Method,
  param?: RequestParams
): Promise<string | null> => {
  const baseURL = networkConfig.host
  if (method === Method.POST) {
    return axios
      .post(baseURL + url, param, {
        responseType: 'blob',
        headers: {
          Authorization: useStore().state.user.token
            ? `Bearer ${useStore().state.user.token}`
            : ''
        }
      })
      .then(res => {
        const blob = new Blob([res.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        })
        return window.URL.createObjectURL(blob)
      })
      .catch(err => {
        console.error('下载失败:', err)
        return null
      })
  } else if (method === Method.GET) {
    return axios.get(baseURL + url, {
      responseType: 'blob',
      headers: {
        Authorization: useStore().state.user.token
          ? `Bearer ${useStore().state.user.token}`
          : ''
      }
    }).then(res => {
      const blob = new Blob([res.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      })
      return window.URL.createObjectURL(blob)
    })
      .catch(err => {
        console.error('下载失败:', err)
        return null
      })
  }
  return Promise.resolve(null)
}

export const downloadFile = (
  url: string,
  method: Method,
  param?: RequestParams
): Promise<string | null> => {
  const baseURL = networkConfig.host
  if (method === Method.POST) {
    return axios
      .post(baseURL + url, param, {
        responseType: 'blob',
        headers: {
          Authorization: useStore().state.user.token
            ? `Bearer ${useStore().state.user.token}`
            : ''
        }
      })
      .then(res => {
        const blob = new Blob([res.data], {
          type: res.headers['content-type']
        })
        return window.URL.createObjectURL(blob)
      })
      .catch(err => {
        console.error('下载失败:', err)
        return null
      })
  } else if (method === Method.GET) {
    return axios.get(baseURL + url, {
      responseType: 'blob',
      headers: {
        Authorization: useStore().state.user.token
          ? `Bearer ${useStore().state.user.token}`
          : ''
      }
    }).then(res => {
      const blob = new Blob([res.data], {
        type: res.headers['content-type']
      })
      return window.URL.createObjectURL(blob)
    })
      .catch(err => {
        console.error('下载失败:', err)
        return null
      })
  }
  return Promise.resolve(null)
}

export const httpWithToken = (token: string) => {
  const config: HttpClientConfig = {
    baseURL: networkConfig.host,
    headers: {
      Authorization: token
    }
  }
  return new HttpClient(config)
}

export const retrieveImage = async(
  url: string,
  token: string,
  param?: RequestParams
): Promise<Blob | null> => {
  try {
    const response = await axios.get(url, {
      params: {
        ...param
      },
      responseType: 'blob',
      headers: {
        Authorization: token
      }
    })

    // 检查响应类型
    const contentType = response.headers['content-type']

    // 如果返回的是JSON（错误信息），则解析错误
    if (contentType && contentType.includes('application/json')) {
      const reader = new FileReader()
      return new Promise((resolve, reject) => {
        reader.onload = () => {
          try {
            const errorData = JSON.parse(reader.result as string)
            console.error('获取图片失败:', errorData)
            reject(new Error(errorData.message || '获取图片失败'))
          } catch (e) {
            reject(new Error('获取图片失败'))
          }
        }
        reader.readAsText(response.data)
      })
    }
    // 返回图片blob
    return response.data
  } catch (error) {
    console.error('获取图片失败:', error)
    return null
  }
}

export const retrieveImageUrl = async(
  url: string,
  token: string,
  param?: RequestParams
): Promise<string | null> => {
  try {
    const blob = await retrieveImage(url, token, param)
    if (blob) {
      return window.URL.createObjectURL(blob)
    }
    return null
  } catch (error) {
    console.error('下载MFA二维码失败:', error)
    return null
  }
}
